import { Link } from "react-router-dom";
import { ArrowLeft, Compass } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-bg px-4 text-center">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-blue/10 text-blue">
        <Compass size={36} strokeWidth={1.5} aria-hidden="true" />
      </div>
      <div className="flex flex-col gap-2">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate">
          404 · Not found
        </p>
        <h1 className="text-3xl font-bold tracking-tight text-navy md:text-4xl">
          We couldn&apos;t find that page.
        </h1>
        <p className="max-w-md text-sm text-slate">
          The link may be broken or the page may have moved. Head back to the
          dashboard or pick a module from the sidebar.
        </p>
      </div>
      <Link
        to="/"
        className={cn(buttonVariants({ variant: "default", size: "default" }))}
      >
        <ArrowLeft size={16} strokeWidth={1.5} aria-hidden="true" />
        Back to dashboard
      </Link>
    </div>
  );
}
